/* tslint:disable */
/* eslint-disable */
/**
 * Poolside API
 * Poolside API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * information required to add info to the registry of the fund (LP is a company)
 * @export
 * @interface ApiPersonRegistry
 */
export interface ApiPersonRegistry {
    /**
     * 
     * @type {string}
     * @memberof ApiPersonRegistry
     */
    personId: string;
    /**
     * 
     * @type {string}
     * @memberof ApiPersonRegistry
     */
    taxResidency: string;
    /**
     * 
     * @type {string}
     * @memberof ApiPersonRegistry
     */
    address: string;
    /**
     * 
     * @type {number}
     * @memberof ApiPersonRegistry
     */
    totalCommitment: number;
    /**
     * 
     * @type {number}
     * @memberof ApiPersonRegistry
     */
    paidInCapital: number;
    /**
     * 
     * @type {number}
     * @memberof ApiPersonRegistry
     */
    callableCapital?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiPersonRegistry
     */
    bankAccount: string;
    /**
     * 
     * @type {Date}
     * @memberof ApiPersonRegistry
     */
    agreementSigningDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApiPersonRegistry
     */
    firstClosingDate: Date;
}

export function ApiPersonRegistryFromJSON(json: any): ApiPersonRegistry {
    return ApiPersonRegistryFromJSONTyped(json, false);
}

export function ApiPersonRegistryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiPersonRegistry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'personId': json['personId'],
        'taxResidency': json['taxResidency'],
        'address': json['address'],
        'totalCommitment': json['totalCommitment'],
        'paidInCapital': json['paidInCapital'],
        'callableCapital': !exists(json, 'callableCapital') ? undefined : json['callableCapital'],
        'bankAccount': json['bankAccount'],
        'agreementSigningDate': (new Date(json['agreementSigningDate'])),
        'firstClosingDate': (new Date(json['firstClosingDate'])),
    };
}

export function ApiPersonRegistryToJSON(value?: ApiPersonRegistry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'personId': value.personId,
        'taxResidency': value.taxResidency,
        'address': value.address,
        'totalCommitment': value.totalCommitment,
        'paidInCapital': value.paidInCapital,
        'callableCapital': value.callableCapital,
        'bankAccount': value.bankAccount,
        'agreementSigningDate': (value.agreementSigningDate.toISOString().substr(0,10)),
        'firstClosingDate': (value.firstClosingDate.toISOString().substr(0,10)),
    };
}

